/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as UnauthorizedPageRouteImport } from './../routes/unauthorized-page'
import { Route as SuccessRouteImport } from './../routes/success'
import { Route as SignUpConfirmRouteImport } from './../routes/sign-up-confirm'
import { Route as SignUpRouteImport } from './../routes/sign-up'
import { Route as SignInRouteImport } from './../routes/sign-in'
import { Route as NewPasswordRouteImport } from './../routes/new-password'
import { Route as InvitationAcceptRouteImport } from './../routes/invitation-accept'
import { Route as GoogleCallbackRouteImport } from './../routes/google-callback'
import { Route as ForgotPasswordRouteImport } from './../routes/forgot-password'
import { Route as PublicFormsRouteImport } from './../routes/_public-forms'
import { Route as AppRouteImport } from './../routes/_app'
import { Route as OnboardingIndexRouteImport } from './../routes/onboarding/index'
import { Route as AppIndexRouteImport } from './../routes/_app/index'
import { Route as OnboardingOrganisationIdRouteImport } from './../routes/onboarding/$organisationId'
import { Route as AppWebhooksRouteImport } from './../routes/_app/webhooks'
import { Route as AppTeamRouteImport } from './../routes/_app/team'
import { Route as AppSystemRouteImport } from './../routes/_app/system'
import { Route as AppReportsRouteImport } from './../routes/_app/reports'
import { Route as AppApiKeysRouteImport } from './../routes/_app/api-keys'
import { Route as PublicLinksVerificationIndexRouteImport } from './../routes/_public-links/verification/index'
import { Route as AppAgentsIndexRouteImport } from './../routes/_app/agents/index'
import { Route as AppAgentsHubIndexRouteImport } from './../routes/_app/agents-hub/index'
import { Route as ProfileVerificationTokenRouteImport } from './../routes/profile/verification/$token'
import { Route as PublicLinksVerificationIdRouteImport } from './../routes/_public-links/verification/$id'
import { Route as PublicFormsFormsIdRouteImport } from './../routes/_public-forms/forms/$id'
import { Route as AppWorkflowsLinksRouteImport } from './../routes/_app/workflows/links'
import { Route as AppSettingsRiskScoringRouteImport } from './../routes/_app/settings/risk-scoring'
import { Route as AppSettingsProductsAndEntitiesRouteImport } from './../routes/_app/settings/products-and-entities'
import { Route as AppSettingsOrganisationRouteImport } from './../routes/_app/settings/organisation'
import { Route as AppSettingsIntegrationsRouteImport } from './../routes/_app/settings/integrations'
import { Route as AppSettingsDocumentTypesRouteImport } from './../routes/_app/settings/document-types'
import { Route as AppSettingsBrandingRouteImport } from './../routes/_app/settings/branding'
import { Route as AppAgentsChatRouteImport } from './../routes/_app/agents/chat'
import { Route as AppAgentsHubRiskScoringRouteImport } from './../routes/_app/agents-hub/risk-scoring'
import { Route as PublicLinksVerificationSelectFormIndexRouteImport } from './../routes/_public-links/verification/select-form/index'
import { Route as AppWorkflowsWorkflowsIndexRouteImport } from './../routes/_app/workflows/workflows/index'
import { Route as AppCaseManagementVerificationsIndexRouteImport } from './../routes/_app/case-management/verifications/index'
import { Route as AppCaseManagementProfilesIndexRouteImport } from './../routes/_app/case-management/profiles/index'
import { Route as AppCaseManagementCasesIndexRouteImport } from './../routes/_app/case-management/cases/index'
import { Route as AppAgentsHubRiskScoringIndexRouteImport } from './../routes/_app/agents-hub/risk-scoring/index'
import { Route as PublicFormsFormsChatIdRouteImport } from './../routes/_public-forms/forms/chat/$id'
import { Route as AppWorkflowsWorkflowsGenerateRouteImport } from './../routes/_app/workflows/workflows/generate'
import { Route as AppCaseManagementVerificationsIdRouteImport } from './../routes/_app/case-management/verifications/$id'
import { Route as AppCaseManagementProfilesIdRouteImport } from './../routes/_app/case-management/profiles/$id'
import { Route as AppCaseManagementCasesIdRouteImport } from './../routes/_app/case-management/cases/$id'
import { Route as AppAgentsChatUuidRouteImport } from './../routes/_app/agents/chat.$uuid'
import { Route as AppAgentsAgentIdChatRouteImport } from './../routes/_app/agents/$agentId/chat'
import { Route as AppAgentsHubRiskScoringPolicyIdRouteImport } from './../routes/_app/agents-hub/risk-scoring/$policyId'
import { Route as AppAgentsAgentIdChatIndexRouteImport } from './../routes/_app/agents/$agentId/chat.index'
import { Route as AppAgentsAgentIdChatUuidRouteImport } from './../routes/_app/agents/$agentId/chat.$uuid'
import { Route as AppWorkflowsWorkflowsFormPreviewIdRouteImport } from './../routes/_app/workflows/workflows/form/preview/$id'
import { Route as AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRouteImport } from './../routes/_app/case-management/cases/data-extraction/$caseId/summary/$userClientId'
import { Route as AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRouteImport } from './../routes/_app/case-management/cases/data-extraction/$caseId/context/$userClientId.$context'

const UnauthorizedPageRoute = UnauthorizedPageRouteImport.update({
  id: '/unauthorized-page',
  path: '/unauthorized-page',
  getParentRoute: () => rootRouteImport,
} as any)
const SuccessRoute = SuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpConfirmRoute = SignUpConfirmRouteImport.update({
  id: '/sign-up-confirm',
  path: '/sign-up-confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const NewPasswordRoute = NewPasswordRouteImport.update({
  id: '/new-password',
  path: '/new-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationAcceptRoute = InvitationAcceptRouteImport.update({
  id: '/invitation-accept',
  path: '/invitation-accept',
  getParentRoute: () => rootRouteImport,
} as any)
const GoogleCallbackRoute = GoogleCallbackRouteImport.update({
  id: '/google-callback',
  path: '/google-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicFormsRoute = PublicFormsRouteImport.update({
  id: '/_public-forms',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const OnboardingOrganisationIdRoute =
  OnboardingOrganisationIdRouteImport.update({
    id: '/onboarding/$organisationId',
    path: '/onboarding/$organisationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppWebhooksRoute = AppWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AppSystemRoute = AppSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppApiKeysRoute = AppApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppRoute,
} as any)
const PublicLinksVerificationIndexRoute =
  PublicLinksVerificationIndexRouteImport.update({
    id: '/_public-links/verification/',
    path: '/verification/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppAgentsIndexRoute = AppAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsHubIndexRoute = AppAgentsHubIndexRouteImport.update({
  id: '/agents-hub/',
  path: '/agents-hub/',
  getParentRoute: () => AppRoute,
} as any)
const ProfileVerificationTokenRoute =
  ProfileVerificationTokenRouteImport.update({
    id: '/profile/verification/$token',
    path: '/profile/verification/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicLinksVerificationIdRoute =
  PublicLinksVerificationIdRouteImport.update({
    id: '/_public-links/verification/$id',
    path: '/verification/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicFormsFormsIdRoute = PublicFormsFormsIdRouteImport.update({
  id: '/forms/$id',
  path: '/forms/$id',
  getParentRoute: () => PublicFormsRoute,
} as any)
const AppWorkflowsLinksRoute = AppWorkflowsLinksRouteImport.update({
  id: '/workflows/links',
  path: '/workflows/links',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRiskScoringRoute = AppSettingsRiskScoringRouteImport.update({
  id: '/settings/risk-scoring',
  path: '/settings/risk-scoring',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsProductsAndEntitiesRoute =
  AppSettingsProductsAndEntitiesRouteImport.update({
    id: '/settings/products-and-entities',
    path: '/settings/products-and-entities',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsOrganisationRoute = AppSettingsOrganisationRouteImport.update({
  id: '/settings/organisation',
  path: '/settings/organisation',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/settings/integrations',
  path: '/settings/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsDocumentTypesRoute =
  AppSettingsDocumentTypesRouteImport.update({
    id: '/settings/document-types',
    path: '/settings/document-types',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsBrandingRoute = AppSettingsBrandingRouteImport.update({
  id: '/settings/branding',
  path: '/settings/branding',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsChatRoute = AppAgentsChatRouteImport.update({
  id: '/agents/chat',
  path: '/agents/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsHubRiskScoringRoute = AppAgentsHubRiskScoringRouteImport.update({
  id: '/agents-hub/risk-scoring',
  path: '/agents-hub/risk-scoring',
  getParentRoute: () => AppRoute,
} as any)
const PublicLinksVerificationSelectFormIndexRoute =
  PublicLinksVerificationSelectFormIndexRouteImport.update({
    id: '/_public-links/verification/select-form/',
    path: '/verification/select-form/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppWorkflowsWorkflowsIndexRoute =
  AppWorkflowsWorkflowsIndexRouteImport.update({
    id: '/workflows/workflows/',
    path: '/workflows/workflows/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCaseManagementVerificationsIndexRoute =
  AppCaseManagementVerificationsIndexRouteImport.update({
    id: '/case-management/verifications/',
    path: '/case-management/verifications/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCaseManagementProfilesIndexRoute =
  AppCaseManagementProfilesIndexRouteImport.update({
    id: '/case-management/profiles/',
    path: '/case-management/profiles/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCaseManagementCasesIndexRoute =
  AppCaseManagementCasesIndexRouteImport.update({
    id: '/case-management/cases/',
    path: '/case-management/cases/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAgentsHubRiskScoringIndexRoute =
  AppAgentsHubRiskScoringIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAgentsHubRiskScoringRoute,
  } as any)
const PublicFormsFormsChatIdRoute = PublicFormsFormsChatIdRouteImport.update({
  id: '/forms/chat/$id',
  path: '/forms/chat/$id',
  getParentRoute: () => PublicFormsRoute,
} as any)
const AppWorkflowsWorkflowsGenerateRoute =
  AppWorkflowsWorkflowsGenerateRouteImport.update({
    id: '/workflows/workflows/generate',
    path: '/workflows/workflows/generate',
    getParentRoute: () => AppRoute,
  } as any)
const AppCaseManagementVerificationsIdRoute =
  AppCaseManagementVerificationsIdRouteImport.update({
    id: '/case-management/verifications/$id',
    path: '/case-management/verifications/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppCaseManagementProfilesIdRoute =
  AppCaseManagementProfilesIdRouteImport.update({
    id: '/case-management/profiles/$id',
    path: '/case-management/profiles/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppCaseManagementCasesIdRoute =
  AppCaseManagementCasesIdRouteImport.update({
    id: '/case-management/cases/$id',
    path: '/case-management/cases/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppAgentsChatUuidRoute = AppAgentsChatUuidRouteImport.update({
  id: '/$uuid',
  path: '/$uuid',
  getParentRoute: () => AppAgentsChatRoute,
} as any)
const AppAgentsAgentIdChatRoute = AppAgentsAgentIdChatRouteImport.update({
  id: '/agents/$agentId/chat',
  path: '/agents/$agentId/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsHubRiskScoringPolicyIdRoute =
  AppAgentsHubRiskScoringPolicyIdRouteImport.update({
    id: '/$policyId',
    path: '/$policyId',
    getParentRoute: () => AppAgentsHubRiskScoringRoute,
  } as any)
const AppAgentsAgentIdChatIndexRoute =
  AppAgentsAgentIdChatIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAgentsAgentIdChatRoute,
  } as any)
const AppAgentsAgentIdChatUuidRoute =
  AppAgentsAgentIdChatUuidRouteImport.update({
    id: '/$uuid',
    path: '/$uuid',
    getParentRoute: () => AppAgentsAgentIdChatRoute,
  } as any)
const AppWorkflowsWorkflowsFormPreviewIdRoute =
  AppWorkflowsWorkflowsFormPreviewIdRouteImport.update({
    id: '/workflows/workflows/form/preview/$id',
    path: '/workflows/workflows/form/preview/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRoute =
  AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRouteImport.update(
    {
      id: '/case-management/cases/data-extraction/$caseId/summary/$userClientId',
      path: '/case-management/cases/data-extraction/$caseId/summary/$userClientId',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRoute =
  AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRouteImport.update(
    {
      id: '/case-management/cases/data-extraction/$caseId/context/$userClientId/$context',
      path: '/case-management/cases/data-extraction/$caseId/context/$userClientId/$context',
      getParentRoute: () => AppRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/google-callback': typeof GoogleCallbackRoute
  '/invitation-accept': typeof InvitationAcceptRoute
  '/new-password': typeof NewPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/sign-up-confirm': typeof SignUpConfirmRoute
  '/success': typeof SuccessRoute
  '/unauthorized-page': typeof UnauthorizedPageRoute
  '/api-keys': typeof AppApiKeysRoute
  '/reports': typeof AppReportsRoute
  '/system': typeof AppSystemRoute
  '/team': typeof AppTeamRoute
  '/webhooks': typeof AppWebhooksRoute
  '/onboarding/$organisationId': typeof OnboardingOrganisationIdRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/agents-hub/risk-scoring': typeof AppAgentsHubRiskScoringRouteWithChildren
  '/agents/chat': typeof AppAgentsChatRouteWithChildren
  '/settings/branding': typeof AppSettingsBrandingRoute
  '/settings/document-types': typeof AppSettingsDocumentTypesRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/organisation': typeof AppSettingsOrganisationRoute
  '/settings/products-and-entities': typeof AppSettingsProductsAndEntitiesRoute
  '/settings/risk-scoring': typeof AppSettingsRiskScoringRoute
  '/workflows/links': typeof AppWorkflowsLinksRoute
  '/forms/$id': typeof PublicFormsFormsIdRoute
  '/verification/$id': typeof PublicLinksVerificationIdRoute
  '/profile/verification/$token': typeof ProfileVerificationTokenRoute
  '/agents-hub/': typeof AppAgentsHubIndexRoute
  '/agents/': typeof AppAgentsIndexRoute
  '/verification/': typeof PublicLinksVerificationIndexRoute
  '/agents-hub/risk-scoring/$policyId': typeof AppAgentsHubRiskScoringPolicyIdRoute
  '/agents/$agentId/chat': typeof AppAgentsAgentIdChatRouteWithChildren
  '/agents/chat/$uuid': typeof AppAgentsChatUuidRoute
  '/case-management/cases/$id': typeof AppCaseManagementCasesIdRoute
  '/case-management/profiles/$id': typeof AppCaseManagementProfilesIdRoute
  '/case-management/verifications/$id': typeof AppCaseManagementVerificationsIdRoute
  '/workflows/workflows/generate': typeof AppWorkflowsWorkflowsGenerateRoute
  '/forms/chat/$id': typeof PublicFormsFormsChatIdRoute
  '/agents-hub/risk-scoring/': typeof AppAgentsHubRiskScoringIndexRoute
  '/case-management/cases/': typeof AppCaseManagementCasesIndexRoute
  '/case-management/profiles/': typeof AppCaseManagementProfilesIndexRoute
  '/case-management/verifications/': typeof AppCaseManagementVerificationsIndexRoute
  '/workflows/workflows/': typeof AppWorkflowsWorkflowsIndexRoute
  '/verification/select-form/': typeof PublicLinksVerificationSelectFormIndexRoute
  '/agents/$agentId/chat/$uuid': typeof AppAgentsAgentIdChatUuidRoute
  '/agents/$agentId/chat/': typeof AppAgentsAgentIdChatIndexRoute
  '/workflows/workflows/form/preview/$id': typeof AppWorkflowsWorkflowsFormPreviewIdRoute
  '/case-management/cases/data-extraction/$caseId/summary/$userClientId': typeof AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRoute
  '/case-management/cases/data-extraction/$caseId/context/$userClientId/$context': typeof AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/google-callback': typeof GoogleCallbackRoute
  '/invitation-accept': typeof InvitationAcceptRoute
  '/new-password': typeof NewPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/sign-up-confirm': typeof SignUpConfirmRoute
  '/success': typeof SuccessRoute
  '/unauthorized-page': typeof UnauthorizedPageRoute
  '/api-keys': typeof AppApiKeysRoute
  '/reports': typeof AppReportsRoute
  '/system': typeof AppSystemRoute
  '/team': typeof AppTeamRoute
  '/webhooks': typeof AppWebhooksRoute
  '/onboarding/$organisationId': typeof OnboardingOrganisationIdRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/agents/chat': typeof AppAgentsChatRouteWithChildren
  '/settings/branding': typeof AppSettingsBrandingRoute
  '/settings/document-types': typeof AppSettingsDocumentTypesRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/organisation': typeof AppSettingsOrganisationRoute
  '/settings/products-and-entities': typeof AppSettingsProductsAndEntitiesRoute
  '/settings/risk-scoring': typeof AppSettingsRiskScoringRoute
  '/workflows/links': typeof AppWorkflowsLinksRoute
  '/forms/$id': typeof PublicFormsFormsIdRoute
  '/verification/$id': typeof PublicLinksVerificationIdRoute
  '/profile/verification/$token': typeof ProfileVerificationTokenRoute
  '/agents-hub': typeof AppAgentsHubIndexRoute
  '/agents': typeof AppAgentsIndexRoute
  '/verification': typeof PublicLinksVerificationIndexRoute
  '/agents-hub/risk-scoring/$policyId': typeof AppAgentsHubRiskScoringPolicyIdRoute
  '/agents/chat/$uuid': typeof AppAgentsChatUuidRoute
  '/case-management/cases/$id': typeof AppCaseManagementCasesIdRoute
  '/case-management/profiles/$id': typeof AppCaseManagementProfilesIdRoute
  '/case-management/verifications/$id': typeof AppCaseManagementVerificationsIdRoute
  '/workflows/workflows/generate': typeof AppWorkflowsWorkflowsGenerateRoute
  '/forms/chat/$id': typeof PublicFormsFormsChatIdRoute
  '/agents-hub/risk-scoring': typeof AppAgentsHubRiskScoringIndexRoute
  '/case-management/cases': typeof AppCaseManagementCasesIndexRoute
  '/case-management/profiles': typeof AppCaseManagementProfilesIndexRoute
  '/case-management/verifications': typeof AppCaseManagementVerificationsIndexRoute
  '/workflows/workflows': typeof AppWorkflowsWorkflowsIndexRoute
  '/verification/select-form': typeof PublicLinksVerificationSelectFormIndexRoute
  '/agents/$agentId/chat/$uuid': typeof AppAgentsAgentIdChatUuidRoute
  '/agents/$agentId/chat': typeof AppAgentsAgentIdChatIndexRoute
  '/workflows/workflows/form/preview/$id': typeof AppWorkflowsWorkflowsFormPreviewIdRoute
  '/case-management/cases/data-extraction/$caseId/summary/$userClientId': typeof AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRoute
  '/case-management/cases/data-extraction/$caseId/context/$userClientId/$context': typeof AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_public-forms': typeof PublicFormsRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/google-callback': typeof GoogleCallbackRoute
  '/invitation-accept': typeof InvitationAcceptRoute
  '/new-password': typeof NewPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/sign-up-confirm': typeof SignUpConfirmRoute
  '/success': typeof SuccessRoute
  '/unauthorized-page': typeof UnauthorizedPageRoute
  '/_app/api-keys': typeof AppApiKeysRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/system': typeof AppSystemRoute
  '/_app/team': typeof AppTeamRoute
  '/_app/webhooks': typeof AppWebhooksRoute
  '/onboarding/$organisationId': typeof OnboardingOrganisationIdRoute
  '/_app/': typeof AppIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/_app/agents-hub/risk-scoring': typeof AppAgentsHubRiskScoringRouteWithChildren
  '/_app/agents/chat': typeof AppAgentsChatRouteWithChildren
  '/_app/settings/branding': typeof AppSettingsBrandingRoute
  '/_app/settings/document-types': typeof AppSettingsDocumentTypesRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/organisation': typeof AppSettingsOrganisationRoute
  '/_app/settings/products-and-entities': typeof AppSettingsProductsAndEntitiesRoute
  '/_app/settings/risk-scoring': typeof AppSettingsRiskScoringRoute
  '/_app/workflows/links': typeof AppWorkflowsLinksRoute
  '/_public-forms/forms/$id': typeof PublicFormsFormsIdRoute
  '/_public-links/verification/$id': typeof PublicLinksVerificationIdRoute
  '/profile/verification/$token': typeof ProfileVerificationTokenRoute
  '/_app/agents-hub/': typeof AppAgentsHubIndexRoute
  '/_app/agents/': typeof AppAgentsIndexRoute
  '/_public-links/verification/': typeof PublicLinksVerificationIndexRoute
  '/_app/agents-hub/risk-scoring/$policyId': typeof AppAgentsHubRiskScoringPolicyIdRoute
  '/_app/agents/$agentId/chat': typeof AppAgentsAgentIdChatRouteWithChildren
  '/_app/agents/chat/$uuid': typeof AppAgentsChatUuidRoute
  '/_app/case-management/cases/$id': typeof AppCaseManagementCasesIdRoute
  '/_app/case-management/profiles/$id': typeof AppCaseManagementProfilesIdRoute
  '/_app/case-management/verifications/$id': typeof AppCaseManagementVerificationsIdRoute
  '/_app/workflows/workflows/generate': typeof AppWorkflowsWorkflowsGenerateRoute
  '/_public-forms/forms/chat/$id': typeof PublicFormsFormsChatIdRoute
  '/_app/agents-hub/risk-scoring/': typeof AppAgentsHubRiskScoringIndexRoute
  '/_app/case-management/cases/': typeof AppCaseManagementCasesIndexRoute
  '/_app/case-management/profiles/': typeof AppCaseManagementProfilesIndexRoute
  '/_app/case-management/verifications/': typeof AppCaseManagementVerificationsIndexRoute
  '/_app/workflows/workflows/': typeof AppWorkflowsWorkflowsIndexRoute
  '/_public-links/verification/select-form/': typeof PublicLinksVerificationSelectFormIndexRoute
  '/_app/agents/$agentId/chat/$uuid': typeof AppAgentsAgentIdChatUuidRoute
  '/_app/agents/$agentId/chat/': typeof AppAgentsAgentIdChatIndexRoute
  '/_app/workflows/workflows/form/preview/$id': typeof AppWorkflowsWorkflowsFormPreviewIdRoute
  '/_app/case-management/cases/data-extraction/$caseId/summary/$userClientId': typeof AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRoute
  '/_app/case-management/cases/data-extraction/$caseId/context/$userClientId/$context': typeof AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/google-callback'
    | '/invitation-accept'
    | '/new-password'
    | '/sign-in'
    | '/sign-up'
    | '/sign-up-confirm'
    | '/success'
    | '/unauthorized-page'
    | '/api-keys'
    | '/reports'
    | '/system'
    | '/team'
    | '/webhooks'
    | '/onboarding/$organisationId'
    | '/onboarding/'
    | '/agents-hub/risk-scoring'
    | '/agents/chat'
    | '/settings/branding'
    | '/settings/document-types'
    | '/settings/integrations'
    | '/settings/organisation'
    | '/settings/products-and-entities'
    | '/settings/risk-scoring'
    | '/workflows/links'
    | '/forms/$id'
    | '/verification/$id'
    | '/profile/verification/$token'
    | '/agents-hub/'
    | '/agents/'
    | '/verification/'
    | '/agents-hub/risk-scoring/$policyId'
    | '/agents/$agentId/chat'
    | '/agents/chat/$uuid'
    | '/case-management/cases/$id'
    | '/case-management/profiles/$id'
    | '/case-management/verifications/$id'
    | '/workflows/workflows/generate'
    | '/forms/chat/$id'
    | '/agents-hub/risk-scoring/'
    | '/case-management/cases/'
    | '/case-management/profiles/'
    | '/case-management/verifications/'
    | '/workflows/workflows/'
    | '/verification/select-form/'
    | '/agents/$agentId/chat/$uuid'
    | '/agents/$agentId/chat/'
    | '/workflows/workflows/form/preview/$id'
    | '/case-management/cases/data-extraction/$caseId/summary/$userClientId'
    | '/case-management/cases/data-extraction/$caseId/context/$userClientId/$context'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/google-callback'
    | '/invitation-accept'
    | '/new-password'
    | '/sign-in'
    | '/sign-up'
    | '/sign-up-confirm'
    | '/success'
    | '/unauthorized-page'
    | '/api-keys'
    | '/reports'
    | '/system'
    | '/team'
    | '/webhooks'
    | '/onboarding/$organisationId'
    | '/onboarding'
    | '/agents/chat'
    | '/settings/branding'
    | '/settings/document-types'
    | '/settings/integrations'
    | '/settings/organisation'
    | '/settings/products-and-entities'
    | '/settings/risk-scoring'
    | '/workflows/links'
    | '/forms/$id'
    | '/verification/$id'
    | '/profile/verification/$token'
    | '/agents-hub'
    | '/agents'
    | '/verification'
    | '/agents-hub/risk-scoring/$policyId'
    | '/agents/chat/$uuid'
    | '/case-management/cases/$id'
    | '/case-management/profiles/$id'
    | '/case-management/verifications/$id'
    | '/workflows/workflows/generate'
    | '/forms/chat/$id'
    | '/agents-hub/risk-scoring'
    | '/case-management/cases'
    | '/case-management/profiles'
    | '/case-management/verifications'
    | '/workflows/workflows'
    | '/verification/select-form'
    | '/agents/$agentId/chat/$uuid'
    | '/agents/$agentId/chat'
    | '/workflows/workflows/form/preview/$id'
    | '/case-management/cases/data-extraction/$caseId/summary/$userClientId'
    | '/case-management/cases/data-extraction/$caseId/context/$userClientId/$context'
  id:
    | '__root__'
    | '/_app'
    | '/_public-forms'
    | '/forgot-password'
    | '/google-callback'
    | '/invitation-accept'
    | '/new-password'
    | '/sign-in'
    | '/sign-up'
    | '/sign-up-confirm'
    | '/success'
    | '/unauthorized-page'
    | '/_app/api-keys'
    | '/_app/reports'
    | '/_app/system'
    | '/_app/team'
    | '/_app/webhooks'
    | '/onboarding/$organisationId'
    | '/_app/'
    | '/onboarding/'
    | '/_app/agents-hub/risk-scoring'
    | '/_app/agents/chat'
    | '/_app/settings/branding'
    | '/_app/settings/document-types'
    | '/_app/settings/integrations'
    | '/_app/settings/organisation'
    | '/_app/settings/products-and-entities'
    | '/_app/settings/risk-scoring'
    | '/_app/workflows/links'
    | '/_public-forms/forms/$id'
    | '/_public-links/verification/$id'
    | '/profile/verification/$token'
    | '/_app/agents-hub/'
    | '/_app/agents/'
    | '/_public-links/verification/'
    | '/_app/agents-hub/risk-scoring/$policyId'
    | '/_app/agents/$agentId/chat'
    | '/_app/agents/chat/$uuid'
    | '/_app/case-management/cases/$id'
    | '/_app/case-management/profiles/$id'
    | '/_app/case-management/verifications/$id'
    | '/_app/workflows/workflows/generate'
    | '/_public-forms/forms/chat/$id'
    | '/_app/agents-hub/risk-scoring/'
    | '/_app/case-management/cases/'
    | '/_app/case-management/profiles/'
    | '/_app/case-management/verifications/'
    | '/_app/workflows/workflows/'
    | '/_public-links/verification/select-form/'
    | '/_app/agents/$agentId/chat/$uuid'
    | '/_app/agents/$agentId/chat/'
    | '/_app/workflows/workflows/form/preview/$id'
    | '/_app/case-management/cases/data-extraction/$caseId/summary/$userClientId'
    | '/_app/case-management/cases/data-extraction/$caseId/context/$userClientId/$context'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PublicFormsRoute: typeof PublicFormsRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  GoogleCallbackRoute: typeof GoogleCallbackRoute
  InvitationAcceptRoute: typeof InvitationAcceptRoute
  NewPasswordRoute: typeof NewPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  SignUpConfirmRoute: typeof SignUpConfirmRoute
  SuccessRoute: typeof SuccessRoute
  UnauthorizedPageRoute: typeof UnauthorizedPageRoute
  OnboardingOrganisationIdRoute: typeof OnboardingOrganisationIdRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  PublicLinksVerificationIdRoute: typeof PublicLinksVerificationIdRoute
  ProfileVerificationTokenRoute: typeof ProfileVerificationTokenRoute
  PublicLinksVerificationIndexRoute: typeof PublicLinksVerificationIndexRoute
  PublicLinksVerificationSelectFormIndexRoute: typeof PublicLinksVerificationSelectFormIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized-page': {
      id: '/unauthorized-page'
      path: '/unauthorized-page'
      fullPath: '/unauthorized-page'
      preLoaderRoute: typeof UnauthorizedPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/success': {
      id: '/success'
      path: '/success'
      fullPath: '/success'
      preLoaderRoute: typeof SuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up-confirm': {
      id: '/sign-up-confirm'
      path: '/sign-up-confirm'
      fullPath: '/sign-up-confirm'
      preLoaderRoute: typeof SignUpConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-password': {
      id: '/new-password'
      path: '/new-password'
      fullPath: '/new-password'
      preLoaderRoute: typeof NewPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation-accept': {
      id: '/invitation-accept'
      path: '/invitation-accept'
      fullPath: '/invitation-accept'
      preLoaderRoute: typeof InvitationAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/google-callback': {
      id: '/google-callback'
      path: '/google-callback'
      fullPath: '/google-callback'
      preLoaderRoute: typeof GoogleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public-forms': {
      id: '/_public-forms'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicFormsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/onboarding/$organisationId': {
      id: '/onboarding/$organisationId'
      path: '/onboarding/$organisationId'
      fullPath: '/onboarding/$organisationId'
      preLoaderRoute: typeof OnboardingOrganisationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/webhooks': {
      id: '/_app/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof AppWebhooksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/system': {
      id: '/_app/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof AppSystemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-keys': {
      id: '/_app/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof AppApiKeysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public-links/verification/': {
      id: '/_public-links/verification/'
      path: '/verification'
      fullPath: '/verification/'
      preLoaderRoute: typeof PublicLinksVerificationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/agents/': {
      id: '/_app/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AppAgentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents-hub/': {
      id: '/_app/agents-hub/'
      path: '/agents-hub'
      fullPath: '/agents-hub/'
      preLoaderRoute: typeof AppAgentsHubIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/profile/verification/$token': {
      id: '/profile/verification/$token'
      path: '/profile/verification/$token'
      fullPath: '/profile/verification/$token'
      preLoaderRoute: typeof ProfileVerificationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public-links/verification/$id': {
      id: '/_public-links/verification/$id'
      path: '/verification/$id'
      fullPath: '/verification/$id'
      preLoaderRoute: typeof PublicLinksVerificationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public-forms/forms/$id': {
      id: '/_public-forms/forms/$id'
      path: '/forms/$id'
      fullPath: '/forms/$id'
      preLoaderRoute: typeof PublicFormsFormsIdRouteImport
      parentRoute: typeof PublicFormsRoute
    }
    '/_app/workflows/links': {
      id: '/_app/workflows/links'
      path: '/workflows/links'
      fullPath: '/workflows/links'
      preLoaderRoute: typeof AppWorkflowsLinksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/risk-scoring': {
      id: '/_app/settings/risk-scoring'
      path: '/settings/risk-scoring'
      fullPath: '/settings/risk-scoring'
      preLoaderRoute: typeof AppSettingsRiskScoringRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/products-and-entities': {
      id: '/_app/settings/products-and-entities'
      path: '/settings/products-and-entities'
      fullPath: '/settings/products-and-entities'
      preLoaderRoute: typeof AppSettingsProductsAndEntitiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/organisation': {
      id: '/_app/settings/organisation'
      path: '/settings/organisation'
      fullPath: '/settings/organisation'
      preLoaderRoute: typeof AppSettingsOrganisationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/document-types': {
      id: '/_app/settings/document-types'
      path: '/settings/document-types'
      fullPath: '/settings/document-types'
      preLoaderRoute: typeof AppSettingsDocumentTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/branding': {
      id: '/_app/settings/branding'
      path: '/settings/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof AppSettingsBrandingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/chat': {
      id: '/_app/agents/chat'
      path: '/agents/chat'
      fullPath: '/agents/chat'
      preLoaderRoute: typeof AppAgentsChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents-hub/risk-scoring': {
      id: '/_app/agents-hub/risk-scoring'
      path: '/agents-hub/risk-scoring'
      fullPath: '/agents-hub/risk-scoring'
      preLoaderRoute: typeof AppAgentsHubRiskScoringRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public-links/verification/select-form/': {
      id: '/_public-links/verification/select-form/'
      path: '/verification/select-form'
      fullPath: '/verification/select-form/'
      preLoaderRoute: typeof PublicLinksVerificationSelectFormIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/workflows/workflows/': {
      id: '/_app/workflows/workflows/'
      path: '/workflows/workflows'
      fullPath: '/workflows/workflows/'
      preLoaderRoute: typeof AppWorkflowsWorkflowsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/case-management/verifications/': {
      id: '/_app/case-management/verifications/'
      path: '/case-management/verifications'
      fullPath: '/case-management/verifications/'
      preLoaderRoute: typeof AppCaseManagementVerificationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/case-management/profiles/': {
      id: '/_app/case-management/profiles/'
      path: '/case-management/profiles'
      fullPath: '/case-management/profiles/'
      preLoaderRoute: typeof AppCaseManagementProfilesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/case-management/cases/': {
      id: '/_app/case-management/cases/'
      path: '/case-management/cases'
      fullPath: '/case-management/cases/'
      preLoaderRoute: typeof AppCaseManagementCasesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents-hub/risk-scoring/': {
      id: '/_app/agents-hub/risk-scoring/'
      path: '/'
      fullPath: '/agents-hub/risk-scoring/'
      preLoaderRoute: typeof AppAgentsHubRiskScoringIndexRouteImport
      parentRoute: typeof AppAgentsHubRiskScoringRoute
    }
    '/_public-forms/forms/chat/$id': {
      id: '/_public-forms/forms/chat/$id'
      path: '/forms/chat/$id'
      fullPath: '/forms/chat/$id'
      preLoaderRoute: typeof PublicFormsFormsChatIdRouteImport
      parentRoute: typeof PublicFormsRoute
    }
    '/_app/workflows/workflows/generate': {
      id: '/_app/workflows/workflows/generate'
      path: '/workflows/workflows/generate'
      fullPath: '/workflows/workflows/generate'
      preLoaderRoute: typeof AppWorkflowsWorkflowsGenerateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/case-management/verifications/$id': {
      id: '/_app/case-management/verifications/$id'
      path: '/case-management/verifications/$id'
      fullPath: '/case-management/verifications/$id'
      preLoaderRoute: typeof AppCaseManagementVerificationsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/case-management/profiles/$id': {
      id: '/_app/case-management/profiles/$id'
      path: '/case-management/profiles/$id'
      fullPath: '/case-management/profiles/$id'
      preLoaderRoute: typeof AppCaseManagementProfilesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/case-management/cases/$id': {
      id: '/_app/case-management/cases/$id'
      path: '/case-management/cases/$id'
      fullPath: '/case-management/cases/$id'
      preLoaderRoute: typeof AppCaseManagementCasesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/chat/$uuid': {
      id: '/_app/agents/chat/$uuid'
      path: '/$uuid'
      fullPath: '/agents/chat/$uuid'
      preLoaderRoute: typeof AppAgentsChatUuidRouteImport
      parentRoute: typeof AppAgentsChatRoute
    }
    '/_app/agents/$agentId/chat': {
      id: '/_app/agents/$agentId/chat'
      path: '/agents/$agentId/chat'
      fullPath: '/agents/$agentId/chat'
      preLoaderRoute: typeof AppAgentsAgentIdChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents-hub/risk-scoring/$policyId': {
      id: '/_app/agents-hub/risk-scoring/$policyId'
      path: '/$policyId'
      fullPath: '/agents-hub/risk-scoring/$policyId'
      preLoaderRoute: typeof AppAgentsHubRiskScoringPolicyIdRouteImport
      parentRoute: typeof AppAgentsHubRiskScoringRoute
    }
    '/_app/agents/$agentId/chat/': {
      id: '/_app/agents/$agentId/chat/'
      path: '/'
      fullPath: '/agents/$agentId/chat/'
      preLoaderRoute: typeof AppAgentsAgentIdChatIndexRouteImport
      parentRoute: typeof AppAgentsAgentIdChatRoute
    }
    '/_app/agents/$agentId/chat/$uuid': {
      id: '/_app/agents/$agentId/chat/$uuid'
      path: '/$uuid'
      fullPath: '/agents/$agentId/chat/$uuid'
      preLoaderRoute: typeof AppAgentsAgentIdChatUuidRouteImport
      parentRoute: typeof AppAgentsAgentIdChatRoute
    }
    '/_app/workflows/workflows/form/preview/$id': {
      id: '/_app/workflows/workflows/form/preview/$id'
      path: '/workflows/workflows/form/preview/$id'
      fullPath: '/workflows/workflows/form/preview/$id'
      preLoaderRoute: typeof AppWorkflowsWorkflowsFormPreviewIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/case-management/cases/data-extraction/$caseId/summary/$userClientId': {
      id: '/_app/case-management/cases/data-extraction/$caseId/summary/$userClientId'
      path: '/case-management/cases/data-extraction/$caseId/summary/$userClientId'
      fullPath: '/case-management/cases/data-extraction/$caseId/summary/$userClientId'
      preLoaderRoute: typeof AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/case-management/cases/data-extraction/$caseId/context/$userClientId/$context': {
      id: '/_app/case-management/cases/data-extraction/$caseId/context/$userClientId/$context'
      path: '/case-management/cases/data-extraction/$caseId/context/$userClientId/$context'
      fullPath: '/case-management/cases/data-extraction/$caseId/context/$userClientId/$context'
      preLoaderRoute: typeof AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppAgentsHubRiskScoringRouteChildren {
  AppAgentsHubRiskScoringPolicyIdRoute: typeof AppAgentsHubRiskScoringPolicyIdRoute
  AppAgentsHubRiskScoringIndexRoute: typeof AppAgentsHubRiskScoringIndexRoute
}

const AppAgentsHubRiskScoringRouteChildren: AppAgentsHubRiskScoringRouteChildren =
  {
    AppAgentsHubRiskScoringPolicyIdRoute: AppAgentsHubRiskScoringPolicyIdRoute,
    AppAgentsHubRiskScoringIndexRoute: AppAgentsHubRiskScoringIndexRoute,
  }

const AppAgentsHubRiskScoringRouteWithChildren =
  AppAgentsHubRiskScoringRoute._addFileChildren(
    AppAgentsHubRiskScoringRouteChildren,
  )

interface AppAgentsChatRouteChildren {
  AppAgentsChatUuidRoute: typeof AppAgentsChatUuidRoute
}

const AppAgentsChatRouteChildren: AppAgentsChatRouteChildren = {
  AppAgentsChatUuidRoute: AppAgentsChatUuidRoute,
}

const AppAgentsChatRouteWithChildren = AppAgentsChatRoute._addFileChildren(
  AppAgentsChatRouteChildren,
)

interface AppAgentsAgentIdChatRouteChildren {
  AppAgentsAgentIdChatUuidRoute: typeof AppAgentsAgentIdChatUuidRoute
  AppAgentsAgentIdChatIndexRoute: typeof AppAgentsAgentIdChatIndexRoute
}

const AppAgentsAgentIdChatRouteChildren: AppAgentsAgentIdChatRouteChildren = {
  AppAgentsAgentIdChatUuidRoute: AppAgentsAgentIdChatUuidRoute,
  AppAgentsAgentIdChatIndexRoute: AppAgentsAgentIdChatIndexRoute,
}

const AppAgentsAgentIdChatRouteWithChildren =
  AppAgentsAgentIdChatRoute._addFileChildren(AppAgentsAgentIdChatRouteChildren)

interface AppRouteChildren {
  AppApiKeysRoute: typeof AppApiKeysRoute
  AppReportsRoute: typeof AppReportsRoute
  AppSystemRoute: typeof AppSystemRoute
  AppTeamRoute: typeof AppTeamRoute
  AppWebhooksRoute: typeof AppWebhooksRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAgentsHubRiskScoringRoute: typeof AppAgentsHubRiskScoringRouteWithChildren
  AppAgentsChatRoute: typeof AppAgentsChatRouteWithChildren
  AppSettingsBrandingRoute: typeof AppSettingsBrandingRoute
  AppSettingsDocumentTypesRoute: typeof AppSettingsDocumentTypesRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsOrganisationRoute: typeof AppSettingsOrganisationRoute
  AppSettingsProductsAndEntitiesRoute: typeof AppSettingsProductsAndEntitiesRoute
  AppSettingsRiskScoringRoute: typeof AppSettingsRiskScoringRoute
  AppWorkflowsLinksRoute: typeof AppWorkflowsLinksRoute
  AppAgentsHubIndexRoute: typeof AppAgentsHubIndexRoute
  AppAgentsIndexRoute: typeof AppAgentsIndexRoute
  AppAgentsAgentIdChatRoute: typeof AppAgentsAgentIdChatRouteWithChildren
  AppCaseManagementCasesIdRoute: typeof AppCaseManagementCasesIdRoute
  AppCaseManagementProfilesIdRoute: typeof AppCaseManagementProfilesIdRoute
  AppCaseManagementVerificationsIdRoute: typeof AppCaseManagementVerificationsIdRoute
  AppWorkflowsWorkflowsGenerateRoute: typeof AppWorkflowsWorkflowsGenerateRoute
  AppCaseManagementCasesIndexRoute: typeof AppCaseManagementCasesIndexRoute
  AppCaseManagementProfilesIndexRoute: typeof AppCaseManagementProfilesIndexRoute
  AppCaseManagementVerificationsIndexRoute: typeof AppCaseManagementVerificationsIndexRoute
  AppWorkflowsWorkflowsIndexRoute: typeof AppWorkflowsWorkflowsIndexRoute
  AppWorkflowsWorkflowsFormPreviewIdRoute: typeof AppWorkflowsWorkflowsFormPreviewIdRoute
  AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRoute: typeof AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRoute
  AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRoute: typeof AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppApiKeysRoute: AppApiKeysRoute,
  AppReportsRoute: AppReportsRoute,
  AppSystemRoute: AppSystemRoute,
  AppTeamRoute: AppTeamRoute,
  AppWebhooksRoute: AppWebhooksRoute,
  AppIndexRoute: AppIndexRoute,
  AppAgentsHubRiskScoringRoute: AppAgentsHubRiskScoringRouteWithChildren,
  AppAgentsChatRoute: AppAgentsChatRouteWithChildren,
  AppSettingsBrandingRoute: AppSettingsBrandingRoute,
  AppSettingsDocumentTypesRoute: AppSettingsDocumentTypesRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsOrganisationRoute: AppSettingsOrganisationRoute,
  AppSettingsProductsAndEntitiesRoute: AppSettingsProductsAndEntitiesRoute,
  AppSettingsRiskScoringRoute: AppSettingsRiskScoringRoute,
  AppWorkflowsLinksRoute: AppWorkflowsLinksRoute,
  AppAgentsHubIndexRoute: AppAgentsHubIndexRoute,
  AppAgentsIndexRoute: AppAgentsIndexRoute,
  AppAgentsAgentIdChatRoute: AppAgentsAgentIdChatRouteWithChildren,
  AppCaseManagementCasesIdRoute: AppCaseManagementCasesIdRoute,
  AppCaseManagementProfilesIdRoute: AppCaseManagementProfilesIdRoute,
  AppCaseManagementVerificationsIdRoute: AppCaseManagementVerificationsIdRoute,
  AppWorkflowsWorkflowsGenerateRoute: AppWorkflowsWorkflowsGenerateRoute,
  AppCaseManagementCasesIndexRoute: AppCaseManagementCasesIndexRoute,
  AppCaseManagementProfilesIndexRoute: AppCaseManagementProfilesIndexRoute,
  AppCaseManagementVerificationsIndexRoute:
    AppCaseManagementVerificationsIndexRoute,
  AppWorkflowsWorkflowsIndexRoute: AppWorkflowsWorkflowsIndexRoute,
  AppWorkflowsWorkflowsFormPreviewIdRoute:
    AppWorkflowsWorkflowsFormPreviewIdRoute,
  AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRoute:
    AppCaseManagementCasesDataExtractionCaseIdSummaryUserClientIdRoute,
  AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRoute:
    AppCaseManagementCasesDataExtractionCaseIdContextUserClientIdContextRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PublicFormsRouteChildren {
  PublicFormsFormsIdRoute: typeof PublicFormsFormsIdRoute
  PublicFormsFormsChatIdRoute: typeof PublicFormsFormsChatIdRoute
}

const PublicFormsRouteChildren: PublicFormsRouteChildren = {
  PublicFormsFormsIdRoute: PublicFormsFormsIdRoute,
  PublicFormsFormsChatIdRoute: PublicFormsFormsChatIdRoute,
}

const PublicFormsRouteWithChildren = PublicFormsRoute._addFileChildren(
  PublicFormsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PublicFormsRoute: PublicFormsRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GoogleCallbackRoute: GoogleCallbackRoute,
  InvitationAcceptRoute: InvitationAcceptRoute,
  NewPasswordRoute: NewPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  SignUpConfirmRoute: SignUpConfirmRoute,
  SuccessRoute: SuccessRoute,
  UnauthorizedPageRoute: UnauthorizedPageRoute,
  OnboardingOrganisationIdRoute: OnboardingOrganisationIdRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  PublicLinksVerificationIdRoute: PublicLinksVerificationIdRoute,
  ProfileVerificationTokenRoute: ProfileVerificationTokenRoute,
  PublicLinksVerificationIndexRoute: PublicLinksVerificationIndexRoute,
  PublicLinksVerificationSelectFormIndexRoute:
    PublicLinksVerificationSelectFormIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
